// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer--footer--2nhzB","links":"Footer--links--1_O8I","socialLinks":"Footer--socialLinks--13Niw","disclaimer":"Footer--disclaimer--1uXyy"};